import * as Inovx from '@shared';
import AnnotationServices from '../services/AnnotationServices';
import FacilityConstants from './../constants/FacilityConstants';
var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var FormHelper = Inovx.Shared.Common.FormHelper;

class AnnotationActions {
    constructor() {
    }

    async createAnnotation(annotation: IViewAnnotationTag) {
        if (!SystemStore.isActionInProgress(FacilityConstants.ANNOTATION_ADD)) {
            SystemActions.beginAction(FacilityConstants.ANNOTATION_ADD);

            try {
                const data = FormHelper.trim(annotation);
                const apiResponse = await AnnotationServices.createAnnotation(data);

                annotation.ID = apiResponse.ID;
                annotation.VersionToken = apiResponse.VersionToken;
                //annotation.key = annotation.ID;
                
                return apiResponse.ID;
            }
            finally {
                SystemActions.endAction(FacilityConstants.ANNOTATION_ADD);
            }
        }
        else {
            this._sendInvalidSave();
        }
    }
    
    async editAnnotation(annotation: IViewAnnotationTag) {
        if (!SystemStore.isActionInProgress(FacilityConstants.ANNOTATION_EDIT)) {

            SystemActions.beginAction(FacilityConstants.ANNOTATION_EDIT);

            try {
                const apiResponse = await AnnotationServices.editAnnotation(annotation);

                annotation.VersionToken = apiResponse.VersionToken;
            }
            finally {
                SystemActions.endAction(FacilityConstants.ANNOTATION_EDIT);
            }
        } else {
            this._sendInvalidSave();
        }        
    }

    async deleteAnnotation(annotation: IViewAnnotationTag) {
        if (!SystemStore.isActionInProgress(FacilityConstants.ANNOTATION_DELETE)) {
            SystemActions.beginAction(FacilityConstants.ANNOTATION_DELETE);

            try {
                await AnnotationServices.deleteAnnotation(annotation);     
            }
            finally {
                SystemActions.endAction(FacilityConstants.ANNOTATION_DELETE);
            }
        }
    }

    private _sendInvalidSave() {
        this._dispatchAction(FacilityConstants.ANNOTATION_INVALID_ADD);
    }

    private _dispatchAction(actionType: string, data?: any) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: actionType,
            data: data
        });
    }
}

const annotationActions = new AnnotationActions();

export default annotationActions;